<mat-form-field class="split-input">
    <mat-label>{{_label}}</mat-label>
    <input matInput required [matDatepicker]="dp" placeholder="{{ _label }} Date" [formControl]="dateControl" (focus)="openPicker(dp)" (click)="openPicker(dp)" #elementToFocus (dateChange)="dateChanged()">
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp="matDatepicker"
                    (closed)="closePicker($event)">
    </mat-datepicker>
    @if (dateControl.hasError('required')) {
<mat-error>You must make a selection</mat-error>
}
</mat-form-field>
@if (showTimePicker) {
<mat-form-field class="split-input">
    <mat-label>{{_label}}</mat-label>
    <input placeholder="{{ _label }} Time" matInput [formControl]="timeControl"
           [ngxTimepicker]="darkPicker" readonly>
    <ngx-material-timepicker class="timepicker" #darkPicker [format]="24" (timeSet)="timeChanged($event)"></ngx-material-timepicker>
</mat-form-field>
}